import { Flex } from "@mantine/core";
import { useTheme } from "@mui/material/styles";
import styled from "styled-components";

const Container = styled(Flex)`
	border-style: solid;
	border-color: ${(props) => props.theme.palette.primary.main};
	border-width: ${(props) => {
		switch (props.borderType) {
			case "left":
				return "0.5px 0 0 0.5px";
			case "right":
				return "0 0.5px 0 0";
			case "top":
				return "0.5px 0 0 0";
			case "bottom":
				return "0 0 0.5px 0";
			case "full":
			default:
				return "0.5px";
		}
	}};
	border-radius: ${(props) => `${props.rd}px` || "4px"};
	overflow: hidden;
	background-color: ${(props) => props.bg || props.theme.palette.background.paper};
`;

export const CardContainer = ({
	children,
	bg,
	w = "auto",
	rd = 4,
	p = 0,
	borderType = "full",
}) => {
	const theme = useTheme();
	
	return (
		<Container 
			borderType={borderType} 
			p={p} 
			rd={rd} 
			bg={bg} 
			w={w}
			theme={theme}
		>
			{children}
		</Container>
	);
};
